
import { BasicService } from "./core/basic.service";

export class UserCenterService extends BasicService {
  //收货地址
  static async getList() {
    const data = await this.http.post('/user/addressList')
    return Promise.resolve(data)
  }  
  static async getArea(level,parent_id) {
    const data = await this.http.post('/other/areaChoice',{level,parent_id})
    return Promise.resolve(data)
  }
  static async addressSave(query) {
    const data = await this.http.post('/user/addressSave',query)
    return Promise.resolve(data)
  }
  static async addressDefault(address_id) {
    const data = await this.http.post('/user/addressDefault',{address_id})
    return Promise.resolve(data)
  }
  static async delectAddress(address_id) {
    const data = await this.http.post('/user/addressDel',{address_id})
    return Promise.resolve(data)
  }
  //安全设置
  static async getBaseInfo() {
    const data = await this.http.post('/user/userBaseInfo')
    return Promise.resolve(data)
  }
  static async pwdChange(query) {
    const data = await this.http.post('/user/pwdChange',query)
    return Promise.resolve(data)
  }
  static async emailChange(query) {
    const data = await this.http.post('/other/emailCodeSend',query)
    return Promise.resolve(data)
  }
  static async changeEmailOrMobile(query) {
    const data =await this.http.post('/user/mobileOrEmailChange',query)
    return Promise.resolve(data) 
  }
  //基本信息
  static async saveUserInfo(query) {
    const data = await this.http.post('/user/userBaseInfoSave',query)
    return Promise.resolve(data)
  }
  static async uploadHeadPic(file) {
    // const data = await this.httpapi.post('/other/fileUpload',{ path_type:type,action:'uploadscrawl',upfile:base64 })
    const datahead = await this.http.upload('/user/userHeadPic?path_type=user&action=uploadimage',{upfile: file});
    return Promise.resolve(datahead)
  }

  static async uploadImage(type,base64) {
    const data = await this.httpapi.post('/File_logic/upload',{ path_type:type,action:'uploadscrawl',upfile:base64 })
    return Promise.resolve(data)
  }
  static async userCertificatesSave(query) {
    const data = await this.http.upload('/user/userCertificatesSave', query)
    return Promise.resolve(data)
  }
  static async getCertificatesSave() {
    const data = await this.http.post('/user/userCertificates')
    return Promise.resolve(data)
  }
  static async userSubmit(requestData) {
    const data = await this.http.upload('/user/userSubmit', requestData)
    return Promise.resolve(data)
  }
  static async userWithdraw() {
    const data = await this.http.post('/user/userWithdraw')
    return Promise.resolve(data)
  }
  //积分中心
  static async accountList(pageQuery) {
    const data = await this.http.post('/score/accountList',pageQuery)
    return Promise.resolve(data)
  }
  //用户收藏
  static async collectList(pageQuery) {
    const data = await this.http.post('/user/collectList',pageQuery)
    return Promise.resolve(data)
  }
  //站内信
  static async messageList(pageQuery) {
    const data = await this.http.post('/user/messageList',pageQuery)
    return Promise.resolve(data)
  }
  //足迹
  static async browsingHistory() {
    const data = await this.http.post('/user/browsingHistory')
    return Promise.resolve(data)
  }

  // 检验token
  static async checkToken() {
    const token = localStorage.getItem('token');
    if(token) {
      const res = !await this.http.post('/user/userTokenCheck', { token });
      return Promise.resolve(res);
    } else {
      return Promise.resolve(false);
    }
  }

  static async getErpEnterPrise() {
    return this.http.post('/business/getList')
  }

  async resetPasswrod(account, checkCode, password, resetWay) {
    return this.http.post('/user/userResetPwd', { account, checkCode, password, resetWay })
  }
}